<template>
	<v-dialog v-model="dialog" max-width="860" persistent>
    <v-card class="elevation-0 pa-3">
      <v-card-title>
        <span class="headline">Invoice insurance</span>
                  <v-spacer></v-spacer>
          <v-btn v-if="!invoiceId" fab small color="primary mx-1" dark @click.native="makeInvoice">
            <v-icon>receipt</v-icon>
          </v-btn>
          <v-btn icon @click.native="print">
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn icon @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>

      </v-card-title>
      <v-divider></v-divider>
            <v-spacer></v-spacer>
            <v-layout wrap grid-list-md id="invoice" ref="invoice" class="invoiceToPrint">

                      <v-card class="invoice elevation-0" style="width:100%">
                          <v-card-title >

                          <m-company-address :settings="settings"></m-company-address>

                          <v-spacer></v-spacer>

                          <span v-if="invoiceId" class="grey--text ma-2 pa-1">
                            <div >Facture N°: <span class="primary--text">{{ invoiceId | zeroFill }}</span></div>
                            <div >Date: <span class="primary--text">{{ selectedItem.date | date }}</span></div>
                          </span>

                          <v-spacer></v-spacer>
                           <span class="grey--text pa-4" style="border: solid 1px #e6e6e6">
                            <div class="headline black--text">{{ selectedItem.name }}</div>
                            <div><span class="grey--text">{{ selectedItem.address }}</span></div>
                            <div ><span class="grey--text">{{ selectedItem.zip }} {{ selectedItem.city }}</span></div>
                            <div class="pt-2"><span class="black--text">Tel: </span> {{ selectedItem.tel }}</div>
                            <div ><span class="black--text">E-mail: </span> {{ selectedItem.email }}</div>
                            <div v-if="client" class="mt-3"><span class="black--text">Client:</span> <span class="primary--text">{{ client.client_firstname }} {{ client.client_lastname }}</span></div>
                          </span>

                          </v-card-title>
          <v-card-title >
            <div class="pre-total">
            <table>
              <tbody>
                <tr class="">
                  <td colspan="9">Total du transport</td><td class="text-right">{{ price.total | currency }}</td>
                </tr>
                <tr class="title line">
                  <td colspan="9" class="title"><strong>Total</strong></td><td class="title text-right"><strong>{{ (price.total) | currency}}</strong></td>
                </tr>
              </tbody>
            </table>
            </div>
          <div class="tva-copy mt-4 pa-2">
            <span>Merci d'effectuer votre versement de <strong>{{ (price.total) | currency}}</strong> des les 15 jours sur notre compte ING <span class="heavy">BE71 3631 7241 0769</span></span><br>
            <span v-if="invoiceId">Avec la communication: <span class="heavy primary--text">{{ invoiceId | zeroFill }}/{{ selectedItem.insuranceId }}</span>

            </span>
          </div>
          </v-card-title>

<div class="v-data-table theme--light">
  <table>
    <thead>
      <tr>
      <th class="text-left">N° transport</th>
      <th class="text-left">Date</th>
      <th class="text-left">Client</th>
      <th class="text-left">Type</th>
      <th class="text-left">Motive</th>
      <th class="text-left">Sub total</th>
      <th class="text-left">Patient</th>
      <th class="text-right">Total</th>

      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, i) in bookings" :key="i">
                              <td >{{ item.mutualPatientID }}</td>
                              <td >{{ item.ap_date }} {{ item.ap_time | formatTime }}</td>
                              <td >{{ item.client_lastname }} {{ item.client_firstname }}</td>
                              <td >{{ item.type | formatIndex(types) }}</td>
                              <td >{{ item.motive | formatMotive(motives) }} </td>
                              <td class="no-break">{{ item.subtotal | currency }} </td>
                              <td class="no-break">{{ -item.mutualPatientAmount | currency }} </td>
                              <td class="no-break text-right">{{ item.total | currency }} </td>


      </tr>
      <tr class="big-line">
        <td colspan="7">Sous total</td><td class="no-break text-right">{{ price.total | currency}}</td>
      </tr>
      <tr class="title big-line">
        <td colspan="6" class="title"><strong>Total</strong></td>
        <td colspan="2" class="title text-right"><strong>{{ price.total | currency}}</strong></td>
      </tr>
    </tbody>
  </table>
</div>

                <div class="tva-copy mt-4 pa-2">
                  <span>Merci d'effectuer votre versement de <strong>{{ (price.total) | currency}}</strong> des les 15 jours sur notre compte ING <span class="heavy">BE71 3631 7241 0769</span></span><br>
                  <span v-if="invoiceId">Avec la communication: <span class="heavy primary--text">{{ invoiceId | zeroFill }}/{{ selectedItem.insuranceId }}</span>

                  </span>
                </div>

                <m-invoice-footer :settings="settings"></m-invoice-footer>

            </v-card>

            </v-layout>






    </v-card>
	</v-dialog>
</template>
<script>

import moment from 'moment';
import WalletMixin from '@/mixins/wallet'
import PrintMixin from '@/mixins/print'
export default {
  name: 'invoiceBooqit',
  props: ['dialog', 'selectedItem', 'filteredBookings', 'start', 'end'],
  mixins: [WalletMixin, PrintMixin],
  data () {
    return {
      menu_date_start: false,
      menu_date_end: false,
      dateFormatted_start: null,
      dateFormatted_end: null,
      currentMonth: moment().format('MMMM YYYY'),
      search: '',
      search_clients: '',
      pagination: {
        sortBy: 'ap_date',
        descending: true
      },
      form: {},
      modes: ['pending', 'closed', 'unfounded', 'canceled'],
      types: {
        to: 'Aller',
        back: 'Retour',
        simple: 'Simple'
      },
      items: [],
      invoiceId: null,
      invoiceDate: null,
      headers: [
        {
          text: 'N° transport',
          width: '10',
          value: 'mutualPatientID'
        },
        { text: '​Date', value: 'ap_date' },
        { text: '​Client', value: 'client_lastname' },
        { text: 'Motive', value: 'motive' },
        { text: 'Type trajet', value: 'type' },
        { text: 'Total du transport' }

      ],
      bookings: [],
      invoiceDone: false
    }
  },
  methods: {
    tableFilter (items, search, filter) {
      search = search.toString().toLowerCase()
      return items.filter(row => filter(row['facture'], search));
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    onRefresh () {
      this.getData();
    },
    close () {
      this.$emit('close');
    },
    print () {
      this.printInvoice();
    },
    getData (status) {
      this.$http
      .post('service/wallet/totalByInsurance', {status: status || 1})
      .then(response => {
        console.log('wallet getData response', response.data);
        this.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getInvoiceId () {
      return new Promise((resolve, reject) => {
        this.$http
        .post('service/wallet/getInsuranceInvoiceId', {status: status || 1})
        .then(response => {
          console.log('getInsuranceInvoiceId response', response.data);
          if (response.data[0].id) {
            this.invoiceId = response.data[0].id;
            resolve(this.invoiceId);
          }
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    setInvoice (data) {
      return new Promise((resolve, reject) => {
        this.$http
        .post('service/wallet/setInvoiceInsurance', data)
        .then(() => {
          resolve(this.invoiceId);
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    makeInvoice () {
      var app = this;
      app.invoiceDone = true;
      this.getInvoiceId().then((id) => {
        app.selectedItem.id = id;
        app.selectedItem.date = moment().format('YYYY-MM-DD');
        var data = {
          invoice: {
            id: id,
            insuranceId: app.selectedItem.insuranceId,
            clientId: (app.client && app.client.client_id) ? app.client.client_id : null,
            date: app.selectedItem.date,
            amount: (app.price.total),
            factuur: this.factuurType || 0
          },
          bookings: app.bookings.map((booking) => { return booking.id })
        }

        console.log('getInvoiceId', data);

        this.setInvoice(data).then((result) => {
          console.log('setInvoice all done ', result);
        });
      });
    },
    getBookings () {
      var app = this;
      console.log('invoice getBookings() ', this.selectedItem);
      app.invoiceDone = false;
      app.invoiceId = this.selectedItem.id || null;
      app.bookings = this.filteredBookings;
      app.client = this.getClient(app.bookings);
      this.calcInvoiceInsurance()
    },
    init (v) {
      if (v) {
        this.getBookings();
        this.getSettings();
      }
    }
  },
  filters: {
    date: function (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    formatIndex (v, obj) {
      return obj[v];
    },
    toTime (sec) {
      var time;
      if (sec > 3600) {
        time = new Date(sec * 1000).toISOString().substr(11, 5) + ' h'
      } else {
        time = new Date(sec * 1000).toISOString().substr(14, 2) + ' mins'
      }
      return time;
    },
    zeroFill (value) {
      var length = 6;
      var number = value;
      if (number) {
        return new Array(length - number.toString().length + 1).join('0') + number;
      }
    }
  },
  watch: {
    dialog (value) {
      this.init(value);
    }
  },
  created () {}
}
</script>
<style lang="scss">
  .no-break {
    white-space: nowrap;
  }
  .tm-toolbar {
    &.v-toolbar {
      background-color: transparent !important;
    }
  }
tr.status {
  &-1 {
    background:rgba(32, 151, 2, 0.1) !important;
  }
  &-2 {
    background:rgba(248, 1, 1, 0.1) !important;
  }
}
#invoice{
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
      padding: 0 2px;
  }
  table.v-table tbody td, table.v-table tbody th {
      height: 40px;
  }
  .big-line{
    border-top: 2px solid rgba(0,0,0,.5) !important;
  }
}
.pre-total {
  table {
    width: 100%;
    .line{
      border-top: 1px solid rgba(0,0,0,.5) !important;
    }
  }

  width: 100%;
  border: solid 1px #e6e6e6;
  padding: 10px;

}
.tva-copy {
  width: 100%;
  .heavy{
    font-weight:600
  }
}
.tva-footer{
 width: 100%;
}

@media print {
    .invoiceToPrint {
        background-color: white;
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        margin: 0;
        padding: 5px;
        font-size: 14px;
        line-height: 14px;
    }
}
</style>
